import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthChanged, signIn as planeSignIn, signUp as planeSignUp, signOutUser, changePassword as planeChangePassword, sendPasswordReset as planeSendPasswordReset, completePasswordReset as planeCompletePasswordReset, onPasswordRecovery } from './data/authPlane';

const AuthContext = createContext({ user: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Dual-plane: on firebase this delivers the raw firebase user (unchanged
    // behavior); on supabase a normalized { uid, email, displayName,
    // isAnonymous } user. Fires immediately with the current state.
    const unsub = onAuthChanged((u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function signUp(email, password) {
  return planeSignUp(email, password);
}

export function signIn(email, password) {
  return planeSignIn(email, password);
}

export function signOut() {
  return signOutUser();
}

export function changePassword(currentPassword, newPassword) {
  return planeChangePassword(currentPassword, newPassword);
}

export function sendPasswordReset(email) {
  return planeSendPasswordReset(email);
}

export function completePasswordReset(newPassword) {
  return planeCompletePasswordReset(newPassword);
}

export { onPasswordRecovery };
